import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { List } from 'immutable';

import { SimpleFormFile } from '../../lib/components/SimpleForm';
import I18n from '../../lib/i18n';
import { actions } from '../../ducks/IpRestrictionForm';
import IpRestrictionRow from './IpRestrictionRow';
import Alert from '../../lib/components/Alert';

class IpRestrictionForm extends React.PureComponent {
  static propTypes = {
    errors: PropTypes.string,
    ipRestrictions: PropTypes.instanceOf(List),
    addForm: PropTypes.func.isRequired,
    removeForm: PropTypes.func.isRequired,
    updateForm: PropTypes.func.isRequired,
    importJsonRequested: PropTypes.func.isRequired,
    importSize: PropTypes.number.isRequired,
  }

  handleClick() {
    this.props.addForm();
  }

  handleUploadJson() {
    const data = new FormData();
    data.append('ip_restriction[json]', this.fileForm.input.files[0]);
    this.fileForm.input.value = '';
    this.props.importJsonRequested(data);
  }

  addFormBtn() {
    const { ipRestrictions, importSize } = this.props;

    if (ipRestrictions.size >= importSize) {
      return null;
    }

    return (
      <div
        className="btn btn-primary ip-restriction-add-btn"
        onClick={() => this.handleClick()}
      >
        +
      </div>
    );
  }

  errorDom(errors) {
    if (errors) {
      return (<Alert message={errors} alertType="danger" />);
    }

    return null;
  }

  render() {
    const { errors, ipRestrictions, removeForm, updateForm } = this.props;

    return (
      <div>
        { this.errorDom(errors) }

        <div className="flex_column">
          <SimpleFormFile
            name="ip_restriction[json]"
            label={I18n.t('ip_restrictions.new.import_json')}
            popoverText={I18n.t('ip_restrictions.new.import_json_help')}
            ref={(c) => { this.fileForm = c; }}
          />

          <div>
            <div
              className="btn btn-primary"
              onClick={() => this.handleUploadJson()}
            >
              {I18n.t('common.action.import')}
            </div>
          </div>
        </div>

        <hr />

        {
          ipRestrictions.map((ipRestriction, index) => (
            <IpRestrictionRow
              key={index}
              showLabel={index === 0}
              index={index}
              ipRestriction={ipRestriction}
              removeForm={removeForm}
              updateForm={updateForm}
            />
          ))
        }

        { this.addFormBtn() }
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    errors: state.$$ipRestrictionFormStore.get('errors'),
    ipRestrictions: state.$$ipRestrictionFormStore.get('ip_restrictions'),
    importSize: state.$$ipRestrictionFormStore.get('import_size'),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators(actions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(IpRestrictionForm);
